module.exports = __webpack_public_path__ + "static/img/Efficiency2022.abff4685.png";